import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressValidationComponent } from './address-validation.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

const materialModules = [MatButtonModule, MatIconModule, MatDividerModule];

@NgModule({
    declarations: [AddressValidationComponent],
    exports: [AddressValidationComponent],
    imports: [CommonModule, TranslateModule.forChild(), ScrollingModule, ...materialModules],
})
export class AddressValidationModule {}
